export default "__VITE_ASSET__CwQqyaXc__"